/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Grid from "@mui/material/Grid";
import { requiredValidator } from "@/src/services/validationRules";
import ValidatorTextField from "@/src/components/FormFields/ValidatorTextField";
import FormLegend from "@/src/components/Form/Common/FormLegend/FormLegend";
import NumberFieldConfigured from "@/src/components/Form/ConfiguredFormElements/NumberFieldConfigured/NumberFieldConfigured";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";
import wizardStyle from "@/src/components/Form/wizardStyle";

type SpecialBurdenProps = {
  path: string;
  index: number;
  product: AbstractCase;
};

export default function SpecialBurden({ path, index, product }: SpecialBurdenProps) {
  return (
    <>
      <Grid sx={wizardStyle.gridTopSpaced} size={12}>
        <FormLegend>Angaben zur {index + 1}. besonderen finanziellen Belastung.</FormLegend>
      </Grid>
      <Grid size={12}>
        <ValidatorTextField name={path + ".description"} label={"Beschreibung"} validators={[requiredValidator("Bitte geben Sie die Beschreibung an")]} />
      </Grid>
      <NumberFieldConfigured caseData={product} fieldPath={path + ".petitionerShare"} fieldType={"money"} numberType={"float"} required />
    </>
  );
}
